import { createContext, useContext, useState, useCallback } from "react";
import { translations } from "../lib/i18n";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("he_lang") || "tr");

  const changeLang = useCallback((next) => {
    setLang(next);
    localStorage.setItem("he_lang", next);
    document.documentElement.lang = next;
  }, []);

  const toggle = useCallback(() => {
    changeLang(lang === "tr" ? "nl" : "tr");
  }, [lang, changeLang]);

  const t = translations[lang];

  return (
    <LanguageContext.Provider value={{ lang, t, changeLang, toggle }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
